<script setup>
    import { ref } from 'vue';
    import AiIntroPage from '@/components/result/ai-literacy/IntroPage.vue';

     const reportData = ref({
        schoolName: "늘푸른초등학교",
        grade: "4",     
        className: "1",  
        studentName: "홍길동"  
    });
</script>
<template>
    <div class="report-inner">         
        <AiIntroPage  
            reportType="parent"         
           :reportData="reportData"
        />
    </div>
</template>